<template>
  <div v-if="load">
    <hr>

    <div class="row mt-4">
      <div class="col-md-4">
        <input v-model="nextGeneric" type="search" class="input form-control" placeholder="Pesquisar por Conteúdo">
      </div>

      <div class="col-md-8">
        <button @click="editable = !editable" :class="{'btn-outline-active': editable }"
                class="btn btn-outline mr-2"
        >{{ editable ? 'Vizualizar' : 'Editar' }}</button>

        <template v-if="editable">
          <button @click="addLine" class="btn btn-outline mr-2">Adicionar linha</button>
          <input accept=".csv, .CSV" type="file" class="btn btn-outline" ref="input" @change="readFile">
        </template>

        <button v-else @click="downloadCSV()" class="btn btn-outline mr-2">Download</button>
      </div>
    </div>

    <hr>

    <EditTable v-if="editable" :rows="showRows" :columns="columns"
               @cloneRow="cloneRow($event)"
               @removeRow="removeRow($event)"
               @move="move($event)"/>
    <ShowTable v-else :rows="showRows" :columns="columns"/>

    <div class="row">
      <div class="col-md-12 my-1">
        <Pagination
          v-model="page"
          :total-count="rows.length"
          :total-pages="totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <div class="form-group mt-1">
      <button @click="$router.push('/admin/custom_tables')" class="btn btn-outline btn-lg mr-2">Cancelar</button>
      <button @click="$router.push(`/admin/custom_tables/${customTable.id}`)"
              class="btn btn-outline btn-lg mr-2">Editar Cofigurações</button>
      <template v-if="editable">
        <button @click="save()" class="btn btn-primary btn-lg mr-2">Aplicar</button>
        <button @click="save(true)" class="btn btn-primary btn-lg mr-2">Salvar</button>
      </template>
    </div>

  </div>
</template>

<script>
  import EditTable from '@/components/admin/custom_tables/work/EditTable'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'
  import ShowTable from '@/components/admin/custom_tables/work/ShowTable'
  import { mapMutations } from 'vuex'

  export default {
    beforeDestroy() {
      clearInterval(this.setIntervalCheckChangeGeneric)
    },
    components: { EditTable, Pagination, ShowTable },
    computed: {
      columns() {
        return this.customTable.columns || []
      },
      rows() {
        const columns = [...this.columns]
        const generic = this.generic.toLowerCase()
        if (!generic) {
          return this.customTable.rows || []
        } else {
          const rows = this.customTable.rows.filter(row => {
            return row.some((field, i) => {
              const column = columns[i]
              let value = field.v
              if (column.type === 'select') {
                const option = column.options.find(o => o[1] === value)
                value = option && option[0]
              }

              return value && value.toLowerCase().includes(generic)
            })
          })

          return rows
        }
      },
      showRows() {
        const start = (this.page - 1) * this.perPage
        return this.rows.slice(start, start + this.perPage)
      },
      totalPages() {
        return Math.ceil(this.rows.length / this.perPage)
      }
    },
    created() {
      this.checkChangeGeneric()

      this.asyncTemplateShow(this.id, {
        after: ({model}) => {
          this.customTable = model
          this.initializeRows()
          this.setNameBreadcrumb('Trabalhar: ' + model.name)
          this.load = true
        }
      })
    },
    data() {
      return {
        customTable: {},
        editable: false,
        generic: '',
        load: false,
        modelPathPrefix: 'admin',
        nameModel: 'CustomTable',
        nextGeneric: '',
        page: 1,
        perPage: 10
      }
    },
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
      addLine(){
        const row = this.customTable.columns.map(c => ({v: c.default}))
        this.customTable.rows.push(row)
      },
      checkChangeGeneric() {
        this.setIntervalCheckChangeGeneric = setInterval(() => {
          if (this.generic !== this.nextGeneric)
            this.generic = this.nextGeneric
        }, 2000)
      },
      cloneRow(index) {
        const clone = [...this.customTable.rows[index]]
        this.customTable.rows.splice(index, 0, clone)

      },
      downloadCSV() {
        const parentCompany = [this.columns.map(c => c.name).join(';')]
        this.rows.forEach(row => parentCompany.push(row.map(f => f.v).join(';')))
        const blob = new Blob([parentCompany.join('\n')])
        this.$parse.buildDownload(`${this.customTable.name}.csv`, blob)
      },
      getColumn(indexColumn) {
        return this.columns[indexColumn]
      },
      initializeRows() {
        this.rows.forEach((row, index) => {
          row.line = index + 1
        })
      },
      move({to, from}) {
        if (from < 0 || from === this.customTable.rows.length)
          return

        const toRow = this.customTable.rows[to]
        const toFrom = this.customTable.rows[from]
        this.$set(this.customTable.rows, from, toRow)
        this.$set(this.customTable.rows, to, toFrom)
      },
      pagination(page) {
        this.page = page
      },
      readFile() {
        const file = this.$refs.input.files[0]
        const reader = new FileReader()

        reader.onloadend = (e) => {
          this.setRowsByCSV(e.target.result)
          this.closeLoad()
        }
        reader.onloadstart = () => this.openLoad()
        reader.readAsText(file, 'UTF-8')
      },
      removeRow(index) {
        this.customTable.rows.splice(index, 1)
      },
      save(close) {
        this.asyncTemplateSave(this.customTable, {
          after: ({model}) => {
            this.$notify.add('CustomTable Salvo com Sucesso!')
            Object.assign(this.customTable, model)
            this.initializeRows()
            this.$emit('saveModel', model)

            if (close)
              this.$router.push('/admin/custom_tables')
          }
        })
      },
      setRowsByCSV(csv) {
        const parentCompany = csv.split('\n').map(line => line.split(';'))

        parentCompany.forEach(line => {
          const newLine = []
          this.customTable.columns.forEach((column, index) => {
            const value = line[index] && line[index].trim() || column.default

            if (column.type === 'select') {
              const option = column.options.map(o => o[1]).includes(value) || []
              newLine.push({l: option[0], v: option[1] || value })
            } else {
              newLine.push({v: value})
            }
          })

          if (newLine.length > 0)
            this.customTable.rows.push(newLine)
        })
      }
    },
    mixins: [ModelMapper],
    name: 'Work',
    props: ['id'],
    watch: {
      generic() {
        this.page = 1
      }
    }
  }
</script>

<style scoped>

</style>